import React from 'react';

const ErrorView = () => {
  return (
    <div>
      <h1>There was an error</h1>
    </div>
  );
};

export default ErrorView;
